/**
 * App Container.
 *
 * Handle authentication and other root-level stuff (for example, banners).
 */

import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router";

import {
  EnvironmentBanner,
  ErgAuth,
  ReloadBanner,
} from "@ergeon/erg-components-react";

import auth from "auth";
import settings from "config/settings";
import {isDataLoaded} from "utils";
const authService = auth();

import api from "v2/api";
import {apiAppData} from "v2/api/AppData";
import {apiAuthUser} from "v2/api/Auth";
import {AppData} from "v2/api/Records";
import Header from "v2/components/Header";
import Loading from "v2/components/Loading";
import ServerError from "v2/components/ServerError";

class AppContainer extends Component {
  static childContextTypes = {
    appData: PropTypes.instanceOf(AppData),
    location: PropTypes.object,
    params: PropTypes.object,
    router: PropTypes.object,
  }
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object,
    params: PropTypes.object,
    router: PropTypes.object,
  }

  state = {
    authError: null,
    authUser: null,
    data: null,
    dataError: null,
    isAuthenticating: true,
  }

  getChildContext() {
    return {
      appData: this.state.data,
      location: this.props.location,
      params: this.props.params,
      router: this.props.router,
    };
  }

  handleLogin = (evt) => {
    evt && evt.preventDefault();
    authService.authenticate();
  }

  handleLogout = (evt) => {
    evt && evt.preventDefault();

    authService.logout();
    Raven.setUserContext();

    this.setState({
      authError: null,
      authUser: null,
    });
  }

  getUser = () => {
    this.setState({
      isAuthenticating: true,
    });

    authService.getUser((error, user) => {
      this.setState({
        authError: error,
        authUser: user ? apiAuthUser(user) : null,
        isAuthenticating: false,
      }, this.loadData);

      if (user && !error) {
        // firebaseAuth.signInWithCustomToken(authService.getToken());
        Raven.setUserContext(user);
      } else {
        Raven.setUserContext();
      }
    });
  }

  loadData = () => {
    api()
      .request({
        method: "options",
        url: "/",
      })
      .then(({data}) => {
        this.setState({
          data: apiAppData(data),
        });
      });
  }

  render() {
    const {authError, authUser, dataError, isAuthenticating} = this.state;

    let content;
    if (!authError && authUser) {
      if (isDataLoaded(this.state)) {
        content = this.props.children;
      } else if (dataError) {
        content = (
          <ServerError>
            <p>
              Cannot load data required for Coordinator UI. In most cases it
              may mean that My Ergeon backend in maintenance mode and will
              return online soon.
            </p>
            <p>
              If error still exists after few minutes please post message
              to <code>#coordinator-app</code> Slack channel about the problem.
            </p>
          </ServerError>
        );
      } else {
        content = <Loading />;
      }
    } else {
      content = (
        <div className="erg-margin-15 ErgAuthContainer">
          <ErgAuth
            appName="Coordinator"
            authService={authService}
            error={authError && authError.reason}
            getUser={this.getUser}
            isLoading={isAuthenticating}
            isLoggedIn={Boolean(authUser)}
            onLogin={this.handleLogin} />
        </div>
      );
    }

    return (
      <div id="app-coordinator-v2">
        <ReloadBanner />
        <EnvironmentBanner className="EnvironmentBanner" env={settings.LEVEL} />
        <Header onLogout={this.handleLogout} user={authUser} />
        {content}
      </div>
    );
  }
}

export default withRouter(AppContainer);



/** WEBPACK FOOTER **
 ** ./src/app/v2/containers/AppContainer.js
 **/